import React from "react";
import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import {
    Docker,
    EndToEndVisibility,
    FasterIssueResolution, K8s, Linux, PrecisionAtScale, Windows
} from "../../components/v2/icons";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../components/v2/agent-integration";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import ProductTour from "../../components/v2/product/product-tour";
import '../../styles/scss/_faq-section.module.scss';

export default function DistributedMonitoring() {
    const { t } = useTranslation("common");
    const featuresData = t('product.distributed-monitoring.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.distributed-monitoring.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.distributed-monitoring.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const cardWithIconData = t('product.distributed-monitoring.cardWithIcon', { returnObjects: true }) as any[]

    const productTourData = t('product.distributed-monitoring.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.distributed-monitoring.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.agentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={<h1><span className={"text-gradient"}>{t('product.distributed-monitoring.hero.title')} </span> <br/> {t('product.distributed-monitoring.hero.titleHighlight')}</h1>}
                                description={t('product.distributed-monitoring.hero.description')}
                                img={"/images/product/distributed-tracing.png"} imgMobile={"/images/product/distributed-tracing-mobile.webp"} imgAlt={t('product.distributed-monitoring.hero.imageAlt')} preloadImg hasActions={true} tips={t('product.hero.tips')}/>


            <section className={'mw-card-with-icon product-page'}>
                <div className={'container'}>
                    <h2>{t('product.distributed-monitoring.section.title')}</h2>
                    <p>{t('product.distributed-monitoring.section.description')}</p>
                    <div className={'card-items'}>
                        <div className={'d-flex card-items'}>
                            <CardWithIcon icon={<FasterIssueResolution />} title={cardWithIconData[0].title}
                                          description={cardWithIconData[0].description}/>
                            <CardWithIcon icon={<PrecisionAtScale />} title={cardWithIconData[1].title}
                                          description={cardWithIconData[1].description}/>
                            <CardWithIcon icon={<EndToEndVisibility />} title={cardWithIconData[2].title}
                                          description={cardWithIconData[2].description}/>

                        </div>
                    </div>
                </div>
            </section>

            <FeaturesMonitoring productFeatures={features} title={<h2>{t('product.distributed-monitoring.features.title')}</h2>} tourId={"distributed-tour"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/clzmqlbhd009alzafkh7lajzt?embed_v=2"} title={productTourData.title} tourId={"distributed-tour"} description={productTourData.description}/>

            <AgentIntegration
                agentDeploy={agentDeploy}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.distributed-monitoring.agentIntegration.title"
                            components={{ highlight: <span className="text-gradient" /> }}
                        />
                    </h2>
                }
                description={agentIntegrationData.description}
            />

            <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.distributed-monitoring.faq.title')}</h2>
                    <p>{t('product.distributed-monitoring.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>
        </>
    )
}